import { PAYMENT_METHODS_ROUTE_PATHS } from './payment-methods/config';
import { RULES_CONFIG_ROUTE_PATHS } from './rules-config/config';
import { WMC_ROUTE_PATHS } from './withdrawal-method-config/config';

export const OPS_HUB_ROUTE_PATHS = {
  opsHub: '/ops-hub',
  debtEngine: '/ops-hub/debt-engine',
  fxConfiguration: '/ops-hub/fx-configuration',
  gatewayRouting: '/ops-hub/gateway-routing',
  ...PAYMENT_METHODS_ROUTE_PATHS,
  ...RULES_CONFIG_ROUTE_PATHS,
  ...WMC_ROUTE_PATHS,
};

export const OPS_HUB_API_PATHS = {
  userDebts: '/v1/api/platform/wallets/users/:userId/debts',
  createDebts: '/v1/api/platform/wallets/debts',
  reliefDebt: '/v1/api/platform/wallets/debts/relief',
  payDebts: '/v1/api/platform/wallets/users/:userId/debts/pay',
  batchDebts: '/v1/api/platform/wallets/debts/batch',
  debtMovements: '/v1/api/platform/wallets/users/:userId/debt-movements',
  debtMovementDetail: '/v1/api/platform/wallets/debts/movements/:movementId',
  currencies: '/v1/api/platform/mercury/currencies',
  walletNotesAuthorize: '/v1/api/platform/wallets/notes',
  walletFreeze: '/v1/api/platform/wallets/csv',
  walletUnfreeze: '/v1/api/platform/wallets/csv/unfreeze',
};
